var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.75002V1.66669M5.85158 4.58335C5.44366 4.85473 5.05645 5.1703 4.6967 5.53005C1.76777 8.45899 1.76777 13.2077 4.6967 16.1367C7.62563 19.0656 12.3744 19.0656 15.3033 16.1367C18.2322 13.2077 18.2322 8.45899 15.3033 5.53005C14.9435 5.1703 14.5563 4.85473 14.1484 4.58335",
    stroke: "#47FE75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/StartIcon.4a76bccca5bd6c1c538bfc35319bd963.svg";
export { ForwardRef as ReactComponent };